import React, { useState } from "react";
import { FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { openPdf } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export default function PayrollDialog({ staff, onClose }) {
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const res = await api.get(`/staff/${staff.id}/payroll`, { params: { month }, responseType: "blob" });
      openPdf(res.data);
      toast.success("Bordro PDF açıldı"); onClose();
    } catch { toast.error("Bordro oluşturulamadı"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={!!staff} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="payroll-dialog">
        <DialogHeader><DialogTitle className="font-heading flex items-center gap-2"><FileText className="h-5 w-5 text-primary" /> Bordro İndir — {staff?.name}</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">Seçilen ayın hakedişleri, ödemeleri, devreden/kalan borç ve izin kullanımı PDF olarak yeni sekmede açılır.</p>
        <Input type="month" value={month} onChange={(e) => setMonth(e.target.value)} data-testid="payroll-month" className="font-mono h-11" />
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>İptal</Button>
          <Button onClick={download} disabled={busy || !month} data-testid="payroll-download" className="gap-2">{busy && <Loader2 className="h-4 w-4 animate-spin" />} PDF Görüntüle</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
